<template>
    <div class="tutorial">
        <div class="tutorial-banner">
            <div class="tutorial-banner-img-cover">
            </div>
            <div class="tutorial-banner-content">
                <div class="tutorial-banner-title">
                    Beginner Chinese for HSK 1 (Part A)
                </div>
                <div class="tutorial-banner-description">
                    The Structured, Comprehensive and Easy Chinese Lessons for Beginners
                </div>
                <div class="tutorial-banner-enroll" @click="purchases()">
                    Enroll in Course for $35
                </div>
            </div>
        </div>
        <div class="tutorial-content">
            <div class="tutorial-content-first">
                <div class="tutorial-content-first-content">
                    <div class="content-left">
                        <div class="courses-section">
                            <p class="courses-section-title">This is the first part of a 3-part course.</p>
                            <ul>
                                <li><span class="highlight">Beginner Chinese (Part A) ($35)</span></li>
                                <li>Beginner Chinese (Part B) ($35)</li>
                                <li>Essential Chinese Words & Sentences ($29)</li>
                            </ul>
                        </div>
                        <div class="courses-explaination">
                            <p class="question">No extra textbook & workbook required!</p>
                            <p class="answer">All the lessons in this course are designed by the EverydayChinese team. Once you enroll in the course, you’ll get all the study materials like the lecture video, mp3, transcript, notes, exercise and pdf. Therefore, you don’t need to buy extra books.</p>
                            <p class="question">What’s inside the Full course?</p>
                            <ul class="answer">
                                <li style="list-style-type: none;">✔ 12 structured video lectures, 12 Chinese pronunciation lessons, 6 essential Chinese word & sentence structure lessons.</li>
                                <li>✔ Over 50 audio lectures that cover approx. 50 daily Chinese conversations, 300 new words & characters, 500 + basic sentences</li>
                                <li>✔ 120+ grammar points & other language tips that you may not learn from traditional textbook.</li>
                                <li>✔ Learn how to write over 300 basic Chinese characters with downloadable PDFs.</li>
                                <li>✔ Over 300 online self-assessment quizzes and exercises.</li>
                                <li>✔ Lifetime access after enrolling the course.</li>
                            </ul>
                            <p class="question">Who is this course for?</p>
                            <p class="answer">If you want to learn Chinese from scratch or refresh your basic knowledge of Mandarin Chinese and build a solid foundation for studying Chinese language, this course is exactly designed for you. Use the coupon code EARLYBIRD to enjoy the early bird discount and start studying Chinese language now.</p>
                        </div>
                    </div>
                    <div class="content-right">
                        <div class="course-purchase" @click="purchases()">
                            <p class="course-type">Buy <br>BEGINNER CHINESE (FULL LESSONS)</p>
                            <p class="course-discount">
                                <span class="discount">$99</span>
                                <span class="discounted"> $59</span>
                            </p>
                        </div>
                        <div class="course-discount-description">
                            Click on the button to save $40 <br> by using the early bird discount in limited time!
                        </div>
                        <div class="course-instructor">
                            <div class="course-instructor-title">
                                Your Instructor
                            </div>
                            <div class="course-instructor-avatar">
                                <img src="../assets/img/mobile/student-pic001.png" >
                            </div>
                            <div class="course-instructor-description">
                                <div class="course-instructor-name">
                                    Online Learning Hub Team
                                </div>
                                <div class="course-instructor-content">
                                    We are a team of instructors dedicated to providing the highest quality of online Mandarin Chinese courses. Dengdeng, a senior instructor, comes from Jiangxi. Joyce is a senior instructor from Hong Kong and Crystal is a course designer from Shenzhen. Our aim is to help students all over the world to learn Mandarin Chinese with ease and explore Chinese language and culture.
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="tutorial-content-second">
                <div class="tutorial-content-second-content">
                    <div class="tutorial-content-second-content-title">
                        Course Curriculum
                    </div>
                    <el-collapse accordion class="course-curriculum">
                        <el-collapse-item v-for="course in courses" :key="course.key">
                            <template #title>
                               {{course.title}}
                            </template>
                            <div class="course-curriculum-content" v-for="child in course.child" :key="child.key">
                                <div class="course-curriculum-content-left">
                                    <img :src="child.icon">
                                    <p> {{ child.content }} </p>
                                </div>
                                <div class="course-curriculum-content-right">
                                    <button @click="redirectCourse()"> Preview </button>
                                </div>
                            </div>
                        </el-collapse-item>
                    </el-collapse>
                </div>
            </div>
            <div class="tutorial-content-third">
                <div class="tutorial-content-third-content">
                    Get Started Now!
                    <div class="tutorial-content-third-enroll" @click="purchases()">
                        Enroll in Course for $35
                    </div>
                </div>
            </div>
            <div class="tutorial-content-fourth">
                <div class="tutorial-content-fourth-content">
                    <div class="frequently-asked">
                        <div class="frequently-asked-title">
                            Frequently Asked Questions
                        </div>
                        <div class="frequently-asked-qna"
                            v-for="question in questions" :key="question.key">
                            <div class="question">
                                {{ question.question }}
                            </div>
                            <div class="answer">
                                {{ question.answer }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <FooterBanner />
    </div>
</template>

<script>
    import FooterBanner from './FooterBanner.vue';
    export default {
        name: 'Tutorial',
        components: {
            FooterBanner,
        },
        data() {
            return {
                /* lesson list */
                courses: [],
                /* Q&A */
                questions: [
                    {
                        question: "Do I need books to study this Course?",
                        answer: "Absolutely not! All the lessons in this course are designed by the EverydayChinese team. Once you enroll in the course, we will offer you the lecture video, mp3, transcript, notes, quiz and pdf. Therefore, you don’t need to get extra books."
                    },
                    {
                        question: "Does this course cover all HSK 1 requirements?",
                        answer: "Our course can be used to prepare for the test of HSK Level 1 as it covers almost all the vocabulary and grammar points of the test of HSK Level 1."
                    },
                    {
                        question: "How long do I have access to the course?",
                        answer: "How does lifetime access sound? After enrolling, you have unlimited access to this course for as long as you like - across any and all devices you own."
                    }
                ]
            }
        },
        mounted () {
            this.getCourseDetail();
        },
        methods: {
            getCourseDetail() {
                this.$api.getJson("course_details").then((response) => {
                    if (response.status == 200) {
                        if (response.data != null) {
                            this.courses = response.data.lessons;
                        }
                    }
                });
            },

            purchases() {
                this.$router.push ({
                    path: "/orderSummary"
                })
            },

            redirectCourse() {
                this.$router.push ({
                    path: "/course"
                })
            }
        },

    }
</script>

<style lang="scss">
    @import "../styles/pc/Tutorial.scss";
    @import "../styles/mobile/Tutorial.scss";
</style>
